import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'

/**
 * The button theme and the link itself rely on this only being used within the subscription-type route
 */
export const ErrorsButtonHome: TOC<unknown> = <template>
  <UiButtonLinkTo data-test-errors-button-home @appearance={{ButtonAppearance.regular}} @route="subscription-type.home">
    {{t "components.errors.buttonHome"}}
  </UiButtonLinkTo>
</template>
